module.exports = __webpack_public_path__ + "media/application/images/svgs/blob-2-45b78847ed1f6bf67257b9b565cce9a0.svg";